export default "__VITE_ASSET__CId$Q6xV__"